import InAppMessage from "./in-app-message.js";
export default class HtmlMessage extends InAppMessage {
  constructor(i, o, e, r, d, t, s, v, n, u, a) {
    super(
      i,
      void 0,
      void 0,
      o,
      e,
      void 0,
      void 0,
      void 0,
      (r = r || InAppMessage.DismissType.MANUAL),
      d,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      t,
      s,
      void 0,
      void 0,
      void 0,
      v,
      void 0,
      void 0,
      void 0,
      n,
      u,
    ),
      (this.messageFields = a),
      (this.messageFields = a);
  }
  io() {
    return !1;
  }
  p(i) {
    if (this.Pe === InAppMessage.qe.ln) {
      if (this.do) return !1;
      this.do = !0;
    }
    return this.ht.Et(i), !0;
  }
  ss() {
    const i = super.ss(HtmlMessage.es);
    return (i[InAppMessage.hs.vo] = this.messageFields), i;
  }
  static an(i) {
    return new HtmlMessage(
      i[InAppMessage.hs.ea],
      i[InAppMessage.hs.xs],
      i[InAppMessage.hs.sa],
      i[InAppMessage.hs.oa],
      i[InAppMessage.hs.pa],
      i[InAppMessage.hs.ga],
      i[InAppMessage.hs.ja],
      i[InAppMessage.hs.va],
      i[InAppMessage.hs.ba],
      i[InAppMessage.hs.CSS],
      i[InAppMessage.hs.vo],
    );
  }
}
HtmlMessage.es = InAppMessage.qe.ln;
